module.exports = __webpack_public_path__ + "static/img/Verstappen.f1e33ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Verstappen.jpg
// module id = HZ9V
// module chunks = 1